module.exports = __webpack_public_path__ + "static/media/file-icons.1524d673.png";